"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTrigger = void 0;
var tooltip_1 = require("@react-aria/tooltip");
var utils_1 = require("@react-aria/utils");
var react_1 = __importStar(require("react"));
var react_stately_1 = require("react-stately");
var __1 = require("../..");
var window_dimensions_1 = require("../../utils/window-dimensions");
var Tooltip_styled_1 = require("./Tooltip.styled");
var copy_1 = require("./copy");
var utils_2 = require("./utils");
var Tooltip = function (_a) {
    var state = _a.state, triggerRef = _a.triggerRef, props = __rest(_a, ["state", "triggerRef"]);
    var tooltipProps = (0, tooltip_1.useTooltip)(props, state).tooltipProps;
    var width = (0, window_dimensions_1.useWindowDimensions)().width;
    var _b = __read((0, react_1.useState)(0), 2), offset = _b[0], setOffset = _b[1];
    var _c = __read((0, react_1.useState)(undefined), 2), position = _c[0], setPosition = _c[1];
    var ref = (0, react_1.createRef)();
    (0, react_1.useEffect)(function () {
        if (triggerRef.current) {
            setPosition((0, utils_2.getTooltipPosition)(triggerRef.current));
        }
        else {
            setPosition(null);
        }
        // Runs on first render only. If we try set initial state the
        // triggerRef.current is still set to null.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            var clientWidth = ref.current.clientWidth;
            var x = ref.current.getBoundingClientRect().x;
            var leftOffset = -x;
            var rightOffset = width - (x + clientWidth);
            if (Math.round(leftOffset) > 0 && offset !== leftOffset) {
                setOffset(leftOffset);
                return;
            }
            if (Math.round(rightOffset) < 0 && offset !== rightOffset) {
                setOffset(rightOffset);
                return;
            }
        }
    }, [position, offset, width, ref]);
    return (react_1.default.createElement(Tooltip_styled_1.StyledTooltip, __assign({}, (0, utils_1.mergeProps)(props, tooltipProps), { offset: offset, position: position || undefined, ref: ref }), props.children));
};
var InfoPrompt = (0, react_1.forwardRef)(function (props, ref) {
    var _a = (0, __1.useComponents)(), Icon = _a.Icon, VisuallyHidden = _a.VisuallyHidden;
    var Copy = (0, __1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Tooltip_styled_1.StyledPrompt, __assign({}, props, { "data-testid": "info-prompt", ref: ref }),
        react_1.default.createElement(Icon, { name: "info" }),
        react_1.default.createElement(VisuallyHidden, null,
            react_1.default.createElement(Copy, { copyKey: "infoPrompt.description" }))));
});
var TooltipTrigger = function (_a) {
    var children = _a.children, _b = _a.delay, delay = _b === void 0 ? 0 : _b, rest = __rest(_a, ["children", "delay"]);
    var _c = __read((0, react_1.useState)(false), 2), isOpen = _c[0], setOpen = _c[1];
    var state = (0, react_stately_1.useTooltipTriggerState)(__assign({ delay: delay, isOpen: isOpen }, rest));
    var ref = (0, react_1.createRef)();
    var _d = (0, tooltip_1.useTooltipTrigger)(__assign({ delay: delay }, rest), state, ref), ariaDescribedBy = _d.triggerProps["aria-describedby"], tooltipProps = _d.tooltipProps;
    var childProps = {
        ref: ref,
        'aria-describedby': ariaDescribedBy,
        tabIndex: 0,
        // Manually control tooltip state got better touch support.
        onMouseEnter: function () { return setOpen(true); },
        onFocus: function () { return setOpen(true); },
        onMouseLeave: function () { return setOpen(false); },
        onBlur: function () { return setOpen(false); },
    };
    return (react_1.default.createElement(Tooltip_styled_1.StyledPromptWrapper, null,
        children ? (react_1.Children.map(children, function (child) {
            return (0, react_1.isValidElement)(child) ? (0, react_1.cloneElement)(child, childProps) : child;
        })) : (react_1.default.createElement(InfoPrompt, __assign({}, childProps))),
        state.isOpen && (react_1.default.createElement(Tooltip, __assign({ "data-testid": "tooltip", state: state, triggerRef: ref }, tooltipProps), rest.tooltip))));
};
exports.TooltipTrigger = TooltipTrigger;
